import { FC } from 'react';
import { Table, Drawer, Text, Button, Form } from 'rsuite';

import EditIcon from '@rsuite/icons/Edit';
import PlusIcon from '@rsuite/icons/Plus';
import TrashIcon from '@rsuite/icons/Trash';
import styles from '../baseCreativesManager.module.scss';
import CreativeForm from 'components/Rsuite/CreativeForm/CreativeForm';

import useCreativeStore from 'store/creativeStore';

import { useCampaignStore } from 'store/campaignStore';

import {
  CreativeManager,
  DefaultCreativeManager,
} from 'core/creative/CreativeManager';
import _ from 'lodash';
import { RsButton } from 'components/Rsuite/Button';
import BindCreativeForm from 'components/Rsuite/BindCreativeForm/BindCreativeForm';
import useCreativeForm from 'components/Rsuite/CreativeForm/Hooks/useCreativeForm';
import { useProductStore } from 'store/productStore';
import { ActionType } from 'core/rtbCampaign/singlePage/common';
import { RsTag } from 'components/Rsuite/Tag';
interface ShopCreativeManagerProps {
  campaignId: string;
  camPaign: any;
}
const creativeManager: CreativeManager = new DefaultCreativeManager();

const { Column, HeaderCell, Cell } = Table;

export const ShopCreativeManager: FC<ShopCreativeManagerProps> = ({
  campaignId,
  camPaign,
}) => {
  const { handleLoading } = useCampaignStore();
  const { actionType: campaignActionType } = useCampaignStore();

  const {
    actionType,
    creative,
    creatives,
    bindCreatives,
    creativesPermission,
    showCreativeManager,
    showBindCreativeManager,
    openCreativeManager,
    openBindCreativeManager,
    handleChangeActionType,
    handleChangeCreative,
    handleAddBindCreatives,
  } = useCreativeStore();
  const { resetProductStore } = useProductStore();

  const { getCreative } = useCreativeForm();
  const handleCreateCreative = () => {
    handleChangeActionType('create');
    openCreativeManager(true);
  };
  const handleOpenBindCreative = () => {
    handleChangeActionType('bind');
    openBindCreativeManager(true);
  };

  const handleCloseBindCreative = () => {
    openBindCreativeManager(false);
    // handleAddBindCreatives([]);
  };

  const handleEditCreative = async (creative) => {
    handleChangeActionType('edit');
    handleLoading(false);
    if (campaignActionType === ActionType.EDIT) {
      const response = await getCreative(creative.id);
      console.log('response', response);
      openCreativeManager(true);
    } else {
      handleChangeCreative(creative);
      openCreativeManager(true);
      handleLoading(false);
    }
  };

  const handleBindCreatives = async () => {
    handleLoading(true);
    try {
      if (
        campaignActionType === ActionType.CREATE ||
        campaignActionType === ActionType.COPY
      ) {
        const response = await creativeManager.getCreative(bindCreatives[0]);
        if (response) {
          handleChangeCreative({
            ...response.basic,
            id: response.basic.creativeId,
            actionType: 'bind',
          });
          handleLoading(false);
        }
        console.log('response', response);
      }
      openBindCreativeManager(false);
    } catch (error) {
      console.error(error);
    } finally {
      handleLoading(false);
    }
  };
  const handleDeleteCreative = () => {
    handleChangeCreative({});
    resetProductStore();
    handleAddBindCreatives([]);
  };
  return (
    <Form layout='horizontal' className='w-full'>
      <Form.Group controlId='data-range-radio'>
        <Form.ControlLabel>素材上傳</Form.ControlLabel>
        <div className='flex'>
          <div className={styles.baseCreativeManager}>
            <Table
              data={
                campaignActionType === ActionType.CREATE ||
                campaignActionType === ActionType.COPY
                  ? _.isEmpty(creative)
                    ? []
                    : [creative]
                  : creatives
              }
              bordered={false}
              cellBordered={false}
              hover={true}
              showHeader={true}
              minHeight={100}
              maxHeight={360}
              headerHeight={40}
              autoHeight={true}
              rowHeight={80}
              renderEmpty={() => (
                <div className='flex h-full items-center justify-center bg-white text-center'>
                  <Text className='font-bold'>請新增或綁定素材</Text>
                </div>
              )}
            >
              <Column width={90} verticalAlign={'middle'} fullText fixed>
                <HeaderCell>ID</HeaderCell>
                <Cell className='id' dataKey='id' />
              </Column>
              <Column width={410} fullText flexGrow={1}>
                <HeaderCell>素材名稱</HeaderCell>
                <Cell className='name' dataKey='name' />
              </Column>
              <Column
                width={220}
                verticalAlign={'middle'}
                align='center'
                fullText
              >
                <HeaderCell>品牌</HeaderCell>
                <Cell
                  className='brandName'
                  dataKey={
                    campaignActionType === ActionType.CREATE ||
                    campaignActionType === ActionType.COPY
                      ? 'bannerExtra.brandName'
                      : 'brandName'
                  }
                />
              </Column>
              <Column width={140} verticalAlign={'middle'} fullText>
                <HeaderCell>主打品ID</HeaderCell>
                <Cell
                  className='productId'
                  dataKey={
                    campaignActionType === ActionType.CREATE ||
                    campaignActionType === ActionType.COPY
                      ? 'product.productId'
                      : 'productId'
                  }
                />
              </Column>
              <Column
                width={80}
                verticalAlign={'middle'}
                align='center'
                fixed='right'
              >
                <HeaderCell>操作</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return (
                      <Button
                        appearance='subtle'
                        onClick={() => handleEditCreative(rowData)}
                        disabled={
                          !creativesPermission[`option_${rowData.creativeType}`]
                        }
                      >
                        <EditIcon />
                      </Button>
                    );
                  }}
                </Cell>
              </Column>
              {(campaignActionType === ActionType.CREATE ||
                campaignActionType === ActionType.COPY) && (
                <Column
                  width={80}
                  verticalAlign={'middle'}
                  align='center'
                  fixed='right'
                >
                  <HeaderCell>刪除</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return (
                        <Button
                          appearance='subtle'
                          onClick={() => handleDeleteCreative()}
                        >
                          <TrashIcon />
                        </Button>
                      );
                    }}
                  </Cell>
                </Column>
              )}
            </Table>
            {(campaignActionType === ActionType.CREATE ||
              campaignActionType === ActionType.COPY) &&
              _.isEmpty(creative) && (
                <div className='flex gap-4 bg-white p-3'>
                  <RsButton
                    disabled={!camPaign?.basic.webBrandNo}
                    onClick={handleCreateCreative}
                  >
                    <PlusIcon color='#413a94' style={{ fontSize: 10 }} />
                    <span className='text-sm text-[#413a94]'>新增素材</span>
                  </RsButton>
                  <RsButton
                    disabled={!camPaign?.basic.webBrandNo}
                    onClick={handleOpenBindCreative}
                  >
                    <PlusIcon color='#413a94' style={{ fontSize: 10 }} />
                    <span className='text-sm text-[#413a94]'>綁定素材</span>
                  </RsButton>
                </div>
              )}
            <Form.ErrorMessage
              show={
                (campaignActionType === ActionType.CREATE ||
                  campaignActionType === ActionType.COPY) &&
                _.isEmpty(creative)
              }
              placement='bottomStart'
            >
              {`尚未新增素材`}
            </Form.ErrorMessage>
          </div>
          <Drawer
            placement={'right'}
            size={actionType === 'bind' ? 'lg' : 'md'}
            open={showCreativeManager}
            onClose={() => openCreativeManager(false)}
          >
            <Drawer.Header>
              <Drawer.Title>
                {(() => {
                  switch (actionType) {
                    case 'create':
                      return '新增素材';
                    case 'edit':
                      return '編輯素材';
                    default:
                      return '';
                  }
                })()}
              </Drawer.Title>
            </Drawer.Header>
            <Drawer.Body>
              <CreativeForm campaignId={campaignId} />
            </Drawer.Body>
          </Drawer>
          <Drawer
            placement={'right'}
            size='lg'
            open={showBindCreativeManager}
            onClose={() => handleCloseBindCreative()}
          >
            <Drawer.Header>
              <Drawer.Title>
                {(() => {
                  switch (actionType) {
                    case 'create':
                      return '新增素材';
                    case 'edit':
                      return '編輯素材';
                    case 'bind':
                      return '綁定素材';
                    default:
                      return '';
                  }
                })()}
              </Drawer.Title>
            </Drawer.Header>
            <Drawer.Body className='p-0'>
              <BindCreativeForm campaignId={campaignId} />
            </Drawer.Body>
            <div className='sticky bottom-0 z-50 flex justify-start gap-4 bg-white p-4 drop-shadow-[0_2px_3px_rgba(97,95,103,0.5)]'>
              <RsButton
                appearance='primary'
                onClick={() => handleBindCreatives()}
                disabled={bindCreatives.length === 0}
              >
                確認綁定
              </RsButton>
              <RsButton
                appearance='subtle'
                onClick={() => handleCloseBindCreative()}
              >
                取消
              </RsButton>
            </div>
          </Drawer>
        </div>
      </Form.Group>
    </Form>
  );
};
